import React from "react";
import PublicNavbar from "../components/layout/PublicNavbar";
import Footer from "../components/layout/Footer";
import Seo from "../components/Seo";
import Hero from "../components/home/Hero";
import IntentPicker from "../components/home/IntentPicker";
import TrustBadgeStrip from "../components/home/TrustBadgeStrip";
import LiveTicker from "../components/home/LiveTicker";
import Problem from "../components/home/Problem";
import SolutionPillars from "../components/home/SolutionPillars";
import HowItWorks from "../components/home/HowItWorks";
import VideoOverview from "../components/home/VideoOverview";
import NotJustDealFlow from "../components/home/NotJustDealFlow";
import MarketplacePreview from "../components/home/MarketplacePreview";
import DiligenceEngine from "../components/home/DiligenceEngine";
import AudienceBlocks from "../components/home/AudienceBlocks";
import PricingAccess from "../components/home/PricingAccess";
import FinalCTA from "../components/home/FinalCTA";
import { useBrand } from "../lib/BrandContext";

/**
 * VenturaZ homepage — the section components live under `components/home/`.
 * This file is intentionally kept slim (composition-only) so edits to any one
 * marketing section stay isolated from the others.
 */
export default function Home() {
  const { intentPickerEnabled } = useBrand();
  return (
    <div className="min-h-screen bg-cream" data-testid="home-page">
      <Seo
        title="VenturaZ | Verified Private-Market Intelligence for Founders & Investors"
        description="VenturaZ builds verified capital profiles for startups and helps investors discover diligence-backed private-market opportunities. Company intelligence, readiness scoring, controlled data access, and secure deal rooms — powered by CorpZo."
        keywords="VenturaZ, private market intelligence, verified startup passport, MCA intelligence, deal room, diligence, DaaS, e-signature, fundraising platform India, CorpZo, investor matchmaking, venture capital India"
      />
      <PublicNavbar />
      <main>
        <Hero />
        {intentPickerEnabled && <IntentPicker />}
        <TrustBadgeStrip />
        <LiveTicker />
        <Problem />
        <SolutionPillars />
        <HowItWorks />
        <VideoOverview />
        <NotJustDealFlow />
        <MarketplacePreview />
        <DiligenceEngine />
        <AudienceBlocks />
        <PricingAccess />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
